document.addEventListener('DOMContentLoaded', function() {
        const openPopupBtn = document.getElementById('openSubscribePopup');
        const closePopupBtn = document.getElementById('closeSubscribebtn');
        const myPopup = document.getElementById('subscribe-popup');

        openPopupBtn.addEventListener('click', function() {
            myPopup.style.display = 'flex'; 
        });

        closePopupBtn.addEventListener('click', function() {
            myPopup.style.display = 'none'; 
        });

    const myButton = document.getElementById('share-link');
    const myElement =document.getElementById('social-share-link');

    myButton.addEventListener('click', function() {
        myElement.classList.toggle('active-class');
    });

    });

document.addEventListener("DOMContentLoaded", function() {
  const input = document.getElementById("recipeSearchInput");
  const items = document.querySelectorAll("#recipeGrid .recipe-item");
  const noMessage = document.getElementById("noRecipesMessage");

  input.addEventListener("keyup", function() {
    const query = input.value.toLowerCase();
    let visibleCount = 0;

    items.forEach(item => {
      const title = item.querySelector(".recipe-title").innerText.toLowerCase();
      if (title.includes(query)) {
        item.style.display = "block";
        visibleCount++;
      } else {
        item.style.display = "none";
      }
    });

    // Show or hide "No recipes found"
    if (visibleCount === 0) {
      noMessage.style.display = "block";
    } else {
      noMessage.style.display = "none";
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll("img").forEach(img => {
    if (!img.hasAttribute("loading")) {
      img.setAttribute("loading", "lazy");
    }
  });
});

// document.addEventListener("DOMContentLoaded", function() {
//    document.getElementById("custom-popup").style.display = "flex";
//     // setTimeout(function() {
     
//     // }, 5000); // show after 5 seconds

//     document.getElementById("popup-close").addEventListener("click", function() {
//       document.getElementById("custom-popup").style.display = "none";
//   });
// });    